import getNewRelicInstance from './getNewRelicInstance';
// This class is used to create consistent error naming before it is passed to New Relic
export class NewRelicError extends Error {
    constructor({ error, location, severity, statusCode }){
        let message;
        if (error instanceof Error) {
            message = error.message;
        } else {
            try {
                message = JSON.stringify(error);
            } catch  {
                message = '"Unable to JSON.stringify() error"';
            }
        }
        const stack = error instanceof Error ? error.stack : undefined;
        const statusCodeMessage = statusCode ? `; statusCode: ${statusCode}` : '';
        const detailedMessage = `message: ${message}; location: ${location}; severity: ${severity}${statusCodeMessage}`;
        super(detailedMessage);
        this.stack = stack;
        Object.setPrototypeOf(this, NewRelicError.prototype);
    }
}
// logs error to New Relic dashboard using noticeError API
const captureError = (errAttributes, customAttributes)=>{
    const nrInstance = getNewRelicInstance();
    nrInstance.noticeError(new NewRelicError(errAttributes), customAttributes);
};
export default captureError;
